import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import * as api from "../../../../backend/request";

interface DropAuditModalProps {
  audit: any;
  onClose: () => void;
  onSuccess: () => void;
}

function DropAuditModal({ audit, onClose, onSuccess }: DropAuditModalProps) {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit() {
    if (!reason.trim()) {
      toast.error("Please provide a reason for dropping the audit.");
      return;
    }

    setSubmitting(true);
    try {
      await api.put(`/api/v1/vendor_location_audits/${audit.id}`, {
        vendor_location_audit: {
          status: "dropped_audit",
          metadata: {
            drop_reason: reason.trim(),
            dropped_date: new Date().toISOString().split("T")[0],
          },
        },
      });
      toast.success("Audit has been dropped successfully.");
      onSuccess();
    } catch (error) {
      const errorMessage =
        (error && (error as any).response && (error as any).response.data && (error as any).response.data.message) || "Failed to drop the audit.";
      toast.error(errorMessage);
    }
    setSubmitting(false);
  }

  return (
    <Modal show={true} backdrop="static" animation={false} dialogClassName="confirm-modal" size="lg" centered>
      <Modal.Header closeButton={true} onHide={onClose}>
        <Modal.Title className="bg">Drop Audit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Are you sure you want to mark this audit as <strong>dropped</strong>?
        </p>
        <div className="row mb-2">
          <div className="col-4 filter-label">
            Reason for Dropping Audit<span className="text-danger">*</span>
          </div>
          <div className="col">
            <textarea
              className="form-control"
              style={{ height: "110px", resize: "none" }}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter reason for dropping this audit..."
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" className="px-4" onClick={onClose} disabled={submitting}>
          No
        </Button>
        <Button variant="primary" className="px-4" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "Dropping..." : "Yes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DropAuditModal;
